// Константы
const DEFAULTS = {
	THUMBS_PER_VIEW: 4,
	SPACE_BETWEEN: 16,
	RESIZE_DELAY: 250,
	ORIENTATION_CHANGE_DELAY: 300
};

// Инициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', () => {
	// Проверка наличия необходимых библиотек
	if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
		console.warn('PhotoSwipe не загружен или не найден в глобальном пространстве имен');
	}

	initProductGalleries();

	// Оптимизированные обработчики событий с дебаунсом
	const debounceResize = debounce(recalculateAllGalleriesHeight, DEFAULTS.RESIZE_DELAY);
	window.addEventListener('resize', debounceResize);

	// Обработчик изменения ориентации устройства
	window.addEventListener('orientationchange', () => {
		setTimeout(recalculateAllGalleriesHeight, DEFAULTS.ORIENTATION_CHANGE_DELAY);
	});
});

/**
 * Функция дебаунса для оптимизации частых вызовов
 */
function debounce(func, delay) {
	let timeout;
	return function () {
		const context = this;
		const args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), delay);
	};
}

/**
 * Пересчет размеров для всех галерей на странице
 */
function recalculateAllGalleriesHeight() {
	const galleries = document.querySelectorAll('.product-gallery');
	galleries.forEach(gallery => {
		const thumbsContainer = gallery.querySelector('.product-gallery-thumbs');
		if (thumbsContainer) {
			const thumbsPerView = parseInt(gallery.dataset.thumbsPerView) || DEFAULTS.THUMBS_PER_VIEW;
			const spaceBetween = parseInt(gallery.dataset.spaceBetween) || DEFAULTS.SPACE_BETWEEN;
			adjustThumbsContainerSize(thumbsContainer, thumbsPerView, spaceBetween);
		}
	});
}

/**
 * Инициализация всех галерей товаров на странице
 */
function initProductGalleries() {
	const galleries = document.querySelectorAll('.product-gallery');
	galleries.forEach(initProductGallery);
}

/**
 * Инициализация отдельной галереи товара
 */
function initProductGallery(gallery) {
	// Получаем настройки из атрибутов данных
	const config = {
		thumbsPerView: parseInt(gallery.dataset.thumbsPerView) || DEFAULTS.THUMBS_PER_VIEW,
		spaceBetween: parseInt(gallery.dataset.spaceBetween) || DEFAULTS.SPACE_BETWEEN,
		remainingCount: parseInt(gallery.dataset.remainingCount) || 0,
		remainingIds: gallery.dataset.remainingIds || '',
		enableZoom: gallery.dataset.enableZoom === 'true'
	};

	// Находим контейнеры для слайдеров
	const mainContainer = gallery.querySelector('.product-gallery-main');
	const thumbsContainer = gallery.querySelector('.product-gallery-thumbs');

	// Если не найдены контейнеры, выходим
	if (!mainContainer || !thumbsContainer) return;

	adjustThumbsContainerSize(thumbsContainer, config.thumbsPerView, config.spaceBetween);

	// Инициализация слайдеров
	const thumbsSwiper = initThumbsSwiper(thumbsContainer, config);
	const mainSwiper = initMainSwiper(mainContainer, thumbsSwiper);

	// Настройка загрузки дополнительных изображений
	setupLoadMoreHandlers(gallery, thumbsSwiper, mainSwiper, config);

	// Инициализация PhotoSwipe, если включена опция увеличения
	if (config.enableZoom) {
		initPhotoSwipe(gallery, mainSwiper);
	}
}

/**
 * Инициализация слайдера миниатюр
 */
function initThumbsSwiper(container, config) {
	return new Swiper(container, {
		direction: 'horizontal',
		slidesPerView: 'auto',
		spaceBetween: config.spaceBetween,
		watchSlidesProgress: true,
		freeMode: true,
		breakpoints: {
			1280: {
				direction: 'vertical'
			}
		}
	});
}

/**
 * Инициализация основного слайдера
 */
function initMainSwiper(container, thumbsSwiper) {
	return new Swiper(container, {
		slidesPerView: 1,
		thumbs: {
			swiper: thumbsSwiper
		}
	});
}

/**
 * Настройка обработчиков для кнопок "Загрузить еще"
 */
function setupLoadMoreHandlers(gallery, thumbsSwiper, mainSwiper, config) {
	if (!config.remainingCount || !config.remainingIds) return;

	// Обработка кнопки в основном слайдере
	const loadMoreButton = gallery.querySelector('.product-gallery-load-more-button');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', () => {
			loadMoreButton.innerHTML = '<span class="loading-spinner"></span>';
			loadMoreButton.disabled = true;
			loadRemainingSlides(gallery, thumbsSwiper, mainSwiper, config.remainingIds);
		});
	}

	// Обработка кнопки в миниатюрах
	const thumbLoadMore = gallery.querySelector('.product-gallery-thumb-load-more');
	if (thumbLoadMore) {
		thumbLoadMore.addEventListener('click', () => {
			const loadMoreBtn = thumbLoadMore.querySelector('.product-gallery-thumb-load-more-button');
			if (loadMoreBtn) {
				loadMoreBtn.innerHTML = '<span class="loading-spinner"></span>';
			}
			loadRemainingSlides(gallery, thumbsSwiper, mainSwiper, config.remainingIds);
		});
	}
}

/**
 * Инициализация PhotoSwipe для галереи
 */
function initPhotoSwipe(gallery, mainSwiper) {
	// Проверяем наличие PhotoSwipe
	if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
		console.warn('PhotoSwipe не загружен');
		return;
	}

	// Получаем все слайды с изображениями
	const slides = gallery.querySelectorAll('.product-gallery-main .swiper-slide');
	let items = createPhotoSwipeItems(slides);

	// Настройка кнопки увеличения
	setupZoomButton(gallery, items, mainSwiper);

	// Обновляем массив изображений при добавлении новых слайдов
	setupMutationObserver(gallery, items);

	// Синхронизация слайдера с PhotoSwipe
	mainSwiper.on('slideChange', () => {
		// Обновляем активный индекс при изменении слайда
	});
}

/**
 * Создание элементов для PhotoSwipe
 */
function createPhotoSwipeItems(slides) {
	const items = [];

	slides.forEach(slide => {
		const img = slide.querySelector('img');
		if (!img) return;

		const imageUrl = img.src;
		const caption = slide.querySelector('.product-gallery-caption');

		// Создаем временное изображение для получения реальных размеров
		const tempImg = new Image();
		tempImg.src = imageUrl;

		const item = {
			src: imageUrl,
			w: tempImg.naturalWidth || 1200,
			h: tempImg.naturalHeight || 1600,
			title: caption ? caption.textContent : ''
		};

		items.push(item);

		// Когда изображение загрузится, обновляем размеры
		tempImg.onload = function () {
			item.w = tempImg.naturalWidth;
			item.h = tempImg.naturalHeight;
		};
	});

	return items;
}

/**
 * Настройка кнопки увеличения
 */
function setupZoomButton(gallery, items, mainSwiper) {
	const zoomButton = gallery.querySelector('.product-gallery-zoom-button');
	if (zoomButton) {
		zoomButton.addEventListener('click', e => {
			e.preventDefault();
			openPhotoSwipe(items, mainSwiper.activeIndex);
		});
	}
}

/**
 * Настройка наблюдателя за изменениями DOM для обновления PhotoSwipe
 */
function setupMutationObserver(gallery, items) {
	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				// Проверяем, добавлены ли новые слайды
				const newSlides = gallery.querySelectorAll('.product-gallery-main .swiper-slide');
				if (newSlides.length > items.length) {
					// Обновляем массив с новыми слайдами
					items.length = 0;
					items.push(...createPhotoSwipeItems(newSlides));
				}
			}
		});
	});

	// Настройка наблюдателя за изменениями
	const swiperWrapper = gallery.querySelector('.product-gallery-main .swiper-wrapper');
	if (swiperWrapper) {
		observer.observe(swiperWrapper, { childList: true });
	}
}

/**
 * Открыть PhotoSwipe с изображениями
 */
function openPhotoSwipe(items, index) {
	// Проверяем, существует ли контейнер для PhotoSwipe на странице
	let pswpElement = document.querySelector('.pswp');

	// Если нет, создаем его
	if (!pswpElement) {
		const pswpHTML = `
		<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="pswp__bg"></div>
			<div class="pswp__scroll-wrap">
				<div class="pswp__container">
					<div class="pswp__item"></div>
					<div class="pswp__item"></div>
					<div class="pswp__item"></div>
				</div>

				<div class="pswp__ui pswp__ui--hidden">
					<div class="pswp__top-bar">
						<div class="pswp__counter"></div>
						<button class="pswp__button pswp__button--close" title="Закрыть (Esc)"></button>
						<button class="pswp__button pswp__button--share" title="Поделиться"></button>
						<button class="pswp__button pswp__button--fs" title="Полный экран"></button>
						<button class="pswp__button pswp__button--zoom" title="Увеличить/уменьшить"></button>
						<div class="pswp__preloader">
							<div class="pswp__preloader__icn">
								<div class="pswp__preloader__cut">
									<div class="pswp__preloader__donut"></div>
								</div>
							</div>
						</div>
					</div>

					<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
						<div class="pswp__share-tooltip"></div>
					</div>

					<button class="pswp__button pswp__button--arrow--left" title="Предыдущее (стрелка влево)"></button>
					<button class="pswp__button pswp__button--arrow--right" title="Следующее (стрелка вправо)"></button>

					<div class="pswp__caption">
						<div class="pswp__caption__center"></div>
					</div>
				</div>
			</div>
		</div>`;

		document.body.insertAdjacentHTML('beforeend', pswpHTML);
		pswpElement = document.querySelector('.pswp');
	}

	// Настройки для PhotoSwipe
	const options = {
		index: index,
		bgOpacity: 0.9,
		showHideOpacity: true,
		closeOnScroll: false,
		shareEl: false,
		fullscreenEl: true,
		zoomEl: true,
		counterEl: true,
		arrowEl: true,
		captionEl: true,
		tapToClose: false,
		tapToToggleControls: true,
		closeOnVerticalDrag: true,
		maxSpreadZoom: 3,
		barsSize: { top: 44, bottom: 'auto' },
		getThumbBoundsFn: function (index) {
			// Находим активный слайд
			const slide = document.querySelector('.product-gallery-main .swiper-slide-active');
			if (!slide) return null;

			// Находим изображение внутри слайда
			const img = slide.querySelector('img');
			if (!img) return null;

			// Получаем координаты изображения
			const rect = img.getBoundingClientRect();

			return {
				x: rect.left,
				y: rect.top + window.pageYOffset,
				w: rect.width
			};
		}
	};

	// Создаем и инициализируем PhotoSwipe
	const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

	// Обновляем размеры изображений при загрузке PhotoSwipe
	gallery.listen('gettingData', function (index, item) {
		if (item.w < 1 || item.h < 1) {
			const img = new Image();
			img.onload = function () {
				item.w = this.width;
				item.h = this.height;
				gallery.invalidateCurrItems();
				gallery.updateSize(true);
			};
			img.src = item.src;
		}
	});

	// Открываем PhotoSwipe
	gallery.init();
}

/**
 * Рассчитать и установить размеры контейнера для слайдера миниатюр
 */
function adjustThumbsContainerSize(thumbsContainer, thumbsPerView, spaceBetween) {
	// Проверяем, находимся ли мы на планшете или десктопе
	// if (window.innerWidth < 768) return;

	// Получаем первый слайд для определения размера
	const thumbSlide = thumbsContainer.querySelector('.swiper-slide');
	if (!thumbSlide) return;

	// Получаем изображение внутри слайда
	const thumbImg = thumbSlide.querySelector('img');
	if (!thumbImg) return;

	// Функция для расчета размеров
	const calculateSize = () => {
		const isVertical = window.innerWidth >= 1280;

		if (isVertical) {
			// Вертикальный слайдер - считаем высоту
			const slideHeight = thumbSlide.offsetHeight;
			const totalHeight = (slideHeight * thumbsPerView) + (spaceBetween * (thumbsPerView - 1));
			thumbsContainer.style.height = totalHeight + 'px';
			thumbsContainer.style.width = 'auto';
		} else {
			// Горизонтальный слайдер - считаем ширину
			const slideWidth = thumbSlide.offsetWidth;
			const totalWidth = (slideWidth * thumbsPerView) + (spaceBetween * (thumbsPerView - 1));
			thumbsContainer.style.width = totalWidth + 'px';
			thumbsContainer.style.height = 'auto';
		}
	};

	// Если изображение уже загружено, рассчитываем сразу
	if (thumbImg.complete) {
		calculateSize();
	} else {
		// Иначе дожидаемся загрузки изображения
		thumbImg.addEventListener('load', calculateSize);
	}
}

/**
 * Загрузка оставшихся слайдов через AJAX
 */
function loadRemainingSlides(gallery, thumbsSwiper, mainSwiper, remainingIds) {
	// Проверяем доступность jQuery
	if (typeof jQuery === 'undefined') {
		console.error('jQuery is not available');
		showLoadError(gallery);
		return;
	}

	// Получаем данные для AJAX
	const ajaxData = getAjaxData();
	console.log(ajaxData);
	// Выполняем AJAX-запрос
	jQuery.ajax({
		url: ajaxData.ajaxUrl,
		type: 'POST',
		data: {
			action: 'load_gallery_slides',
			nonce: ajaxData.nonce,
			ids: remainingIds
		},
		success: function (response) {
			if (response.success && response.data && response.data.slides) {
				addSlidesToGallery(gallery, thumbsSwiper, mainSwiper, response.data.slides);
			} else {
				console.error('Error loading slides:', response);
				showLoadError(gallery);
			}
		},
		error: function (xhr, status, error) {
			console.error('AJAX error:', error);
			console.error('HTTP status:', xhr.status);
			console.error('HTTP status text:', xhr.statusText);
			showLoadError(gallery);
		}
	});
}

/**
 * Получение данных для AJAX-запроса
 */
function getAjaxData() {
	// Создаем объект с данными для AJAX, если он не определен
	if (typeof window.blocksWallcoverData === 'undefined') {
		console.warn('blocksWallcoverData is not defined, using fallback');
		return {
			ajaxUrl: '/wp-admin/admin-ajax.php',
			nonce: ''
		};
	}

	return {
		ajaxUrl: window.blocksWallcoverData.ajaxUrl || '/wp-admin/admin-ajax.php',
		nonce: window.blocksWallcoverData.nonce || ''
	};
}

/**
 * Показать ошибку загрузки
 */
function showLoadError(gallery) {
	// Восстанавливаем кнопки загрузки
	const loadMoreButton = gallery.querySelector('.product-gallery-load-more-button');
	if (loadMoreButton) {
		loadMoreButton.innerHTML = 'Error loading images';
		loadMoreButton.disabled = false;
	}

	const thumbLoadMore = gallery.querySelector('.product-gallery-thumb-load-more');
	if (thumbLoadMore) {
		const loadMoreBtn = thumbLoadMore.querySelector('.product-gallery-thumb-load-more-button');
		if (loadMoreBtn) {
			loadMoreBtn.innerHTML = '!';
		}
	}
}
/**
 * Добавление загруженных слайдов в галерею
 */
function addSlidesToGallery(gallery, thumbsSwiper, mainSwiper, slides) {
	// Находим контейнеры
	const thumbsWrapper = gallery.querySelector('.product-gallery-thumbs .swiper-wrapper');
	const mainWrapper = gallery.querySelector('.product-gallery-main .swiper-wrapper');

	if (!thumbsWrapper || !mainWrapper) return;

	// Удаляем кнопки "Загрузить еще"
	removeLoadMoreButtons(gallery);

	// Добавляем загруженные слайды
	slides.forEach(slide => {
		// Добавляем слайд в основной слайдер
		mainWrapper.appendChild(createMainSlide(slide));

		// Добавляем слайд в слайдер миниатюр
		thumbsWrapper.appendChild(createThumbSlide(slide));
	});

	// Обновляем слайдеры
	updateSlidersAfterLoad(gallery, thumbsSwiper, mainSwiper);
}

/**
 * Удаление кнопок "Загрузить еще"
 */
function removeLoadMoreButtons(gallery) {
	const thumbLoadMore = gallery.querySelector('.product-gallery-thumb-load-more');
	const mainLoadMore = gallery.querySelector('.product-gallery-load-more-slide');

	if (thumbLoadMore) thumbLoadMore.remove();
	if (mainLoadMore) mainLoadMore.remove();
}

/**
 * Создание слайда для основного слайдера
 */
function createMainSlide(slideData) {
	const newMainSlide = document.createElement('div');
	newMainSlide.className = 'swiper-slide product-gallery-slide';

	const img = document.createElement('img');
	img.src = slideData.url;
	img.alt = slideData.alt || '';
	newMainSlide.appendChild(img);

	if (slideData.caption) {
		const caption = document.createElement('div');
		caption.className = 'product-gallery-caption';
		caption.textContent = slideData.caption;
		newMainSlide.appendChild(caption);
	}

	return newMainSlide;
}

/**
 * Создание слайда для слайдера миниатюр
 */
function createThumbSlide(slideData) {
	const newThumbSlide = document.createElement('div');
	newThumbSlide.className = 'swiper-slide product-gallery-thumb';

	const thumbImg = document.createElement('img');
	thumbImg.src = slideData.url;
	thumbImg.alt = slideData.alt || '';
	newThumbSlide.appendChild(thumbImg);

	return newThumbSlide;
}

/**
 * Обновление слайдеров после загрузки новых слайдов
 */
function updateSlidersAfterLoad(gallery, thumbsSwiper, mainSwiper) {
	// Обновляем слайдеры
	thumbsSwiper.update();
	mainSwiper.update();

	// Пересчитываем высоту контейнера миниатюр
	const thumbsPerView = parseInt(gallery.dataset.thumbsPerView) || DEFAULTS.THUMBS_PER_VIEW;
	const spaceBetween = parseInt(gallery.dataset.spaceBetween) || DEFAULTS.SPACE_BETWEEN;
	const thumbsContainer = gallery.querySelector('.product-gallery-thumbs');

	if (thumbsContainer) {
		// Устанавливаем высоту для контейнера миниатюр
		thumbsContainer.style.overflow = 'visible';
		// Добавляем небольшую задержку для гарантии, что слайды полностью загружены
		setTimeout(() => {
			adjustThumbsContainerSize(thumbsContainer, thumbsPerView, spaceBetween);
		}, 100);
	}
} 